import React from "react";
import { formatInrWithoutDecimal } from "../../utils/formatWithoutDecimal";

const Banks = ({ className = "", bankBalancesData }) => {
  const bankAmountData = Array.isArray(bankBalancesData?.accounts)
    ? bankBalancesData.accounts.map((account) => ({
        bank: account?.bank_name || account?.holder_name || "Bank",
        balance: Number(account?.current_balance ?? 0),
      }))
    : [];

  return (
    <div
      className={`col-lg-6 col-md-12 col-12 ${className}`.trim()}
      style={{ alignSelf: "flex-start" }}
    >
      <div
        className="card shadow-none border-0"
        style={{
          marginTop: 0,
          minHeight: "195px",
          height: "195px",
          borderRadius: "18px",
          background: "#FFFFFF",
          border: "1px solid #E2E8F0",
        }}
      >
        <div className="card-body px-4 pt-2 pb-2">
          <div className="d-flex align-items-center justify-content-between mb-1">
            <div>
              <span
                className="d-block"
                style={{
                  fontSize: "0.82rem",
                  color: "#334155",
                  fontWeight: 500,
                  letterSpacing: "0.2px",
                  marginTop: "4px",
                }}
              >
                Bank Balance
              </span>
            </div>
            <span style={{ color: "#0F172A", fontSize: "0.86rem", fontWeight: 700 }}>
              {formatInrWithoutDecimal(bankBalancesData?.total_balance ?? 0)}
            </span>
          </div>

          <div
            className="d-grid"
            style={{
              gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
              gap: "8px",
              marginTop: "24px",
            }}
          >
            {(bankAmountData.length > 0
              ? bankAmountData
              : [{ bank: "No Accounts", balance: 0 }]
            ).map((item) => (
              <div
                key={item.bank}
                className="dashboard-glass-inner d-flex align-items-center justify-content-between"
                style={{
                  padding: "6px 8px",
                  borderRadius: "10px",
                  background: "#F8FAFC",
                  border: "1px solid #E2E8F0",
                }}
              >
                <span
                  style={{
                    color: "#334155",
                    fontSize: "0.8rem",
                    fontWeight: 600,
                  }}
                >
                  {item.bank}
                </span>
                <span
                  style={{
                    color: "#0F172A",
                    fontSize: "0.82rem",
                    fontWeight: 700,
                  }}
                >
                  {formatInrWithoutDecimal(item.balance)}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banks;
